import apiRequest from "./apiRequest";

export const createPayment = async (data, token) => {
  const payment = await apiRequest.post("v2/subscriptions", data, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return payment.data;
};

export const getAdvancedPricing = async (token) => {
  const payment = await apiRequest.get("/v2/subscriptions/price", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return payment.data;
};
